import { useDisclosure } from '@mantine/hooks';
import { ILinkedEmail } from '@/entities/admin-app/email';
import { useAppSelector } from '@hooks/redux/redux';
import { useUpdateInfo } from '@hooks/users/useUpdateUser';
import { isAdmin } from '@/lib/utils/access';
import { ProfileSectionEnum, ProfileUpdateTypeEnum } from '@/types/enums/users';
import { ILinkedEmailsProps } from '@/containers/pages/user/components/sections/linked-emails';

export const useLinkedEmail = (props: ILinkedEmailsProps) => {
  const { listLinkedEmails, sectionFormKey, form, editUser, currentId, isCreateUserPage } = props;

  const [opened, { open, close }] = useDisclosure(false);
  const [isOpenedCreateModal, { open: openCreateModal, close: closeCreateModal }] =
    useDisclosure(false);
  const currentUser = useAppSelector((state) => state.userInfo.User);
  const { saveUpdate, isLoading, isSuccess } = useUpdateInfo();

  const handleAddEmail = async (email: ILinkedEmail) => {
    form?.insertListItem(`${sectionFormKey}`, { ...email });
    if (editUser && currentId) {
      await saveUpdate({
        Type: ProfileUpdateTypeEnum.Email,
        Data: {
          [ProfileSectionEnum.LinkedEmail]: [...(listLinkedEmails ?? []), email],
          Id: currentId
        }
      });
    }
  };

  const visibleCreateButton = isCreateUserPage || (isAdmin(currentUser) && editUser);
  const listEmails = listLinkedEmails?.filter((email) => email.Email) || [];

  return {
    handleAddEmail,
    openCreateModal,
    closeCreateModal,
    open,
    opened,
    close,
    isLoading,
    isSuccess,
    isOpenedCreateModal,
    visibleCreateButton,
    listEmails
  };
};
